// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { FaUser, FaWallet, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/images/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fecha o menu mobile quando mudar de rota
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleMobileMenuClick = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Previne o scroll quando o menu mobile está aberto
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : '';
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo-container" aria-label="Ir para página inicial">
          <img src={logo} alt="G3 Rastreamento" className="logo" />
        </Link>

        <button 
          className="mobile-menu-button"
          onClick={handleMobileMenuClick}
          aria-label={isMobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`} role="navigation">
          <div className="nav-links">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Home
            </Link>
            <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
              A Empresa
            </Link>
            <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`}>
              Serviços
            </Link>
            <Link to="/contracts" className={`nav-link ${isActive('/contracts') ? 'active' : ''}`}>
              Contratos
            </Link>
            <Link to="/scheduling" className={`nav-link ${isActive('/scheduling') ? 'active' : ''}`}>
              Agendamento
            </Link>
            <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
              Contato
            </Link>
          </div>

          <div className="nav-buttons">
            <a 
              href="https://g3.rastrosystem.com.br/acl/login/?next=/" 
              className="nav-button client-area"
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Acessar área do cliente"
            >
              <FaUser className="button-icon" />
              <span>Área do Cliente</span>
            </a>
            <a 
              href="https://g3.rastrosystem.com.br/segunda-via/" 
              className="nav-button financial"
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Acessar área financeira"
            >
              <FaWallet className="button-icon" />
              <span>Financeiro</span>
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;